export default "__VITE_ASSET__BIK_yJKq__"